// Function date
    import functionsFiltres from '@/functions/filter.js'
    import functionsTris from '@/functions/tris.js'
    import params from '@/param/param.js'
    import param from '../param/param';





    // Déclaration tableau réutilisable
        const mois = new Array('Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre');
        const moisnumerique = new Array('01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12');
        const jours = new Array('Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi');
        const jours_fr = new Array('Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi');
        const joursInput = new Array('dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi');
    
    // Déclaration functions
        const date = {
            date(date){
                var currentdate = ''
                
                if(date === ''){
                    currentdate = new Date();
                }else{
                    currentdate = new Date(date)
                }
                
                var annee = currentdate.getFullYear();
                var moi = currentdate.getMonth();
                var jour = currentdate.getDay();
                let j = currentdate.getDate()
                if(j < 10){
                    j = '0'+j
                }

                let maDate = {}

                maDate.date_fr = j + '/' + moisnumerique[moi] + '/' + annee
                maDate.date_en = annee + '-' + moisnumerique[moi] + '-' + j
                maDate.ecrit = jours[jour]+' '+j+' '+mois[moi]+' '+annee+'';
                maDate.compa = annee + moisnumerique[moi] + j

                maDate.annee = annee
                
                maDate.mois = mois[moi]
                maDate.moisnumerique = moisnumerique[moi]
                
                maDate.jour = jours[jour]
                maDate.journumerique = jour
                
                maDate.date = j
                maDate.datenumber = Number(j)

                maDate.time = currentdate.getHours()+" h "+currentdate.getMinutes()+" min "+currentdate.getSeconds()+" sec";
                maDate.timenumerique = currentdate.getHours() + ':' + currentdate.getMinutes() + ':' + currentdate.getSeconds()
                maDate.heure = currentdate.getHours()
                maDate.minute = currentdate.getMinutes()

                return maDate
            }, 

            getDateAnte(date, id) {
                let today = ''
                if(date != ''){
                    today = new Date(date);
                }else{
                    today = new Date();
                }
                const yesterday = new Date(today);
                yesterday.setDate(today.getDate() - id);
                return yesterday.toISOString().slice(0, 10); // Retourne la date au format YYYY-MM-DD
            },

            getDateJour(date, jour){
                const jourCible = param.joursSemaineFR.indexOf(jour)
                const aujourdhui = this.date(date).date_en
                const jourActuel = param.joursSemaineFR.indexOf(this.date(aujourdhui).jour);

                let difference = jourCible - jourActuel;
                if (difference <= 0) {
                    difference += 7;
                }

                let prochaineDate = this.getDateAnte(aujourdhui, -difference)

                return prochaineDate;
            },

            getFirstAndLastDayOfMonth: function(monthName, year, nbrMois, nbrAnnee) {
                let monMois = mois.indexOf(monthName) + 1
                if(Number(mois.indexOf(monthName)) + Number(nbrMois) < 0){
                    nbrAnnee = -1
                    monMois = 12 + (Number(mois.indexOf(monthName)) + Number(nbrMois))
                }else{
                    monMois = (Number(mois.indexOf(monthName)) + Number(nbrMois)) + 1
                }

                if(monMois < 10){
                    monMois = '0' + monMois
                }

                // Crée un objet Date avec le premier jour du mois et l'année donnés
                let firstDayOfMonth = new Date((Number(year) + nbrAnnee) + '-' + monMois + '-01');
                firstDayOfMonth = firstDayOfMonth.toISOString().slice(0, 10);
                
                // Obtient le dernier jour du mois en ajoutant 1 mois au premier jour du mois, puis en soustrayant 1 jour
                let lastDayOfMonth = new Date((Number(year) + nbrAnnee), moisnumerique[Number(monMois) - 1], 1);
                lastDayOfMonth = lastDayOfMonth.toISOString().slice(0, 10);
                return {
                    firstDay: firstDayOfMonth,
                    lastDay: lastDayOfMonth
                };
            },

            arrondiMinute(heure, min, arrondi){
                let minArrondies = Math.round((min) / arrondi) * arrondi
                if(minArrondies < 10){
                    return heure +':0'+ minArrondies
                }else if(minArrondies === 60){
                    return Number(heure + 1) + ":00"
                }else{
                    return heure + ':' + minArrondies
                }
            },

            conversionTime: function(time){
                let timeText = time.toString()
                let timeheure = ''

                if(timeText !== '0'){

                    let splitTime = timeText.split('.')

                    if(splitTime.length == 2){
                        if(splitTime[1].length === 1){
                            splitTime[1] = splitTime[1] + '0'
                        }
                    }


                    let min = ''

                    if(Number(splitTime[1]) > 12.5 && Number(splitTime[1]) <= 27.5){
                        min = "15"
                    }else if(Number(splitTime[1]) > 37.5 && Number(splitTime[1]) <= 62.5){
                        min = "30"
                    }else if(Number(splitTime[1]) > 62.5 && Number(splitTime[1]) <= 87.5){
                        min = "45"
                    }else{
                        min = "00"
                        splitTime[0]++
                    }

                    timeheure = splitTime[0] + 'h' + min
                }else{
                    timeheure = '0h'
                }


                return timeheure

            },

            conversionDate: function(annee, mois, jour){
                if(mois < 10){
                    mois = '0'+mois
                }

                if(jour < 10){
                    jour = '0' + jour
                }

                return annee + '-' + mois + '-' + jour
            },

            conversionTimeExacte: function(time){
                let timeText = time.toString()
                let timeheure = ''

                if(timeText !== '0'){

                    let splitTime = timeText.split('.')

                    if(splitTime.length == 2){
                        if(splitTime[1].length === 1){
                            splitTime[1] = splitTime[1] + '0'
                        }
                    }


                    timeheure = splitTime[0] + 'h' + splitTime[1].slice(0, 2)
                }else{
                    timeheure = '0h00'
                }


                return timeheure

            },

            conversionTimeNumNbr(time){
                let split = time.toString().split('.')
                let heure = split[0]
                let minute = split[1].slice(0, 2)

                return Number(heure) + "h" + Math.round(Number(Number(minute) * 60 / 100))
            },
            
            conversionTimeNum: function(heure, minute){
                return Number(heure) + Number(minute) / 60
            },

            conversionTimeEntierNum: function(time){
                let heure = time.split('h')[0]
                let minute = time.split('h')[1]
                return Number(heure) + Number(minute) / 60
            },

            calculDureeTrajet: function(element, item){
                return Math.ceil((Number(element.distance) * 2 / Number(item.vitesse) + 2) * 60 / 15) * 15 / 60
            },

            calculDureeTrajetMinMax(item){
                let mesModeles = functionsFiltres.filterRange(functionsFiltres.filterRange(functionsTris.orderBy(dataBase.modelesavions, 'AZ', 'modele'), 'categorie', 1, functionsTris.orderNumberType(functionsFiltres.filterSome(dataBase.aeroports, 'id', item.destination, 'aeroport'), 'AZ', 'categorie')[0].categorie), 'distance', item.distance, 40075)
                let min = functionsTris.orderNumberType(mesModeles, 'ZA', 'vitesse')[0]
                let max = functionsTris.orderNumberType(mesModeles, 'AZ', 'vitesse')[0]

                let durees = {
                    min: this.calculDureeTrajet(item, min),
                    max: this.calculDureeTrajet(item, max)
                }

                return durees
            },

            calculDureeTrajetSimple: function(element, item){
                return (Number(element.distance) / Number(item.vitesse))
            },

            calculateDuration(element, type, id) {
                let date1 = new Date(element[type].date.year + '-' + element[type].date.month + '-' + element[type].date.day);
                let date2 = new Date(this.date('').date_en);
                tmp = date2 - date1
                var diff = {}							// Initialisation du retour
                var tmp = date2 - date1;

                tmp = Math.floor(tmp/1000);             // Nombre de secondes entre les 2 dates
                diff.sec = tmp % 60;					// Extraction du nombre de secondes

                tmp = Math.floor((tmp-diff.sec)/60);	// Nombre de minutes (partie entière)
                diff.min = tmp % 60;					// Extraction du nombre de minutes

                tmp = Math.floor((tmp-diff.min)/60);	// Nombre d'heures (entières)
                diff.hour = tmp % 24;					// Extraction du nombre d'heures
                
                tmp = Math.floor((tmp-diff.hour)/24);	// Nombre de jours restants
                if(id === 'day'){
                    diff.day = tmp;
                }else{
                    diff.day = tmp % 30;

                    tmp = Math.floor((tmp-diff.day)/30);	// Nombre de jours restants
                    
                    if(id === 'month'){
                        diff.month = tmp;
                    }else{
                        diff.month = tmp % 12;

                        tmp = Math.floor((tmp-diff.month)/12);	// Nombre de jours restants
                        if(id === 'year'){
                            diff.year = tmp;
                        }else{
                            diff.year = tmp % 12;                    
                        }
                    }


                }
                return diff;
            },

            calculHeureFin: function(jour, heure, min, duree, id){
                let dureeSplit = duree.split('h')
                let minA = Number(min) + Number(dureeSplit[1])
                let heureA = Number(heure) + Number(dureeSplit[0])
                let jourA = jour

                if(minA >= 60){
                    minA = minA - 60
                    heureA = heureA + 1
                }

                if(minA === 0){
                    minA = '00'
                }else if(minA < 10){
                    minA = '0' + minA
                }

                if(heureA >= 24){
                    let index = jours.indexOf(jourA) + Math.trunc(heureA / 24)
                    heureA = heureA - 24 * Math.trunc(heureA / 24)
                    if(index >= 7){
                        index = index - 7
                    }
                    jourA = jours[index]
                }
                if(heureA < 10){
                    heureA = '0'+heureA
                }

                let heureF = heureA + 'h' + minA

                let all = {}
                all.day = jourA
                all.heure = heureA
                all.minute = minA

                if(id === 'jour'){
                    return jourA
                }else if(id === 'heure'){
                    return heureF
                }else{
                    return all
                }
            },

            inputDate(date){
                var currentdate = ''
                
                if(date === ''){
                    currentdate = new Date();
                }else{
                    currentdate = new Date(date)
                }
                
                var annee = currentdate.getFullYear();
                var moi = currentdate.getMonth();
                var jour = currentdate.getDay();
                let j = currentdate.getDate()
                if(j < 10){
                    j = '0'+j
                }

                let maDate = {}


                maDate.year = annee
                maDate.month = Number(moisnumerique[moi])
                maDate.day = Number(j)
                maDate.year_fr = annee
                maDate.month_fr = moisnumerique[moi]
                maDate.day_fr = j

                return maDate
            },

            compareDate(date, separateur){
                let dateSplit = date.split(separateur)
                let maDateCompare = ''

                if(separateur === '-'){
                    for(let i = 0; dateSplit.length > i; i++){
                        maDateCompare = maDateCompare + dateSplit[i]
                    }
                }
                return maDateCompare

            },

            filterDateHorairesOuverture(listeElements, dates){
                let listeJoursDates = new Array()
                let listeElementsJoursO = new Array()
                let listeElementsJoursOE = new Array()
                let listeElementsJoursFE = new Array()
                let resultats = {
                    fermeture: false,
                    min_matin: '',
                    max_matin: '',
                    min_apres_midi: '',
                    max_apres_midi: '',
                    heure: [],
                    minute: []
                }

                dates.forEach(date =>{
                    let jour = this.date(date).jour
                    listeJoursDates.push(jour)
                })

                listeJoursDates.forEach(date => {
                    functionsFiltres.filterInTypeArrayDeux(listeElements, date, 'horaires', 'jours').forEach(element =>{
                        if(element.type === 'Extraordinaire'){
                            if(this.date(element.horaires.debut).compa <= this.date('').compa && this.date('').compa <= this.date(element.horaires.fin).compa){
                                if(element.horaires.ouvert === false){
                                    listeElementsJoursFE.push(element)
                                }else{
                                    listeElementsJoursOE.push(element)
                                }
                            }
                        }else{
                            listeElementsJoursO.push(element)
                        }
                    })
                })

                if(listeElementsJoursFE.length > 0){
                    resultats = {
                        fermeture: true,
                        heure: [],
                        minute: []
                    }
                }else if(listeElementsJoursOE.length > 0){
                    if(listeElementsJoursOE[0].horaires.ouvert === true){
                        if(listeElementsJoursOE[0].horaires.matin.ouvert === true){
                            resultats.min_matin = listeElementsJoursOE[0].horaires.matin.ouverture
                            resultats.max_matin = listeElementsJoursOE[0].horaires.matin.fermeture
                            params.heureNumerique.forEach(heure => {
                                if(Number(listeElementsJoursOE[0].horaires.matin.ouverture.slice(0, 2)) <= Number(heure) && Number(heure) <= Number(listeElementsJoursOE[0].horaires.matin.fermeture.slice(0, 2))){
                                    resultats.heure.push(heure)
                                }
                            })

                            resultats.minute = params.minuteNumeriqueQH
                        }

                        if(listeElementsJoursOE[0].horaires.apres_midi.ouvert === true){
                            resultats.min_apres_midi = listeElementsJoursOE[0].horaires.apres_midi.ouverture
                            resultats.max_apres_midi = listeElementsJoursOE[0].horaires.apres_midi.fermeture
                            params.heureNumerique.forEach(heure => {
                                if(Number(listeElementsJoursOE[0].horaires.apres_midi.ouverture.slice(0, 2)) <= Number(heure) && Number(heure) <= Number(listeElementsJoursOE[0].horaires.apres_midi.fermeture.slice(0, 2))){
                                    resultats.heure.push(heure)
                                }
                            })

                            params.minuteNumeriqueQH.forEach(min => {
                                if(resultats.minute.includes(min)){

                                }else{
                                    resultats.minute = params.minuteNumeriqueQH
                                }
                            })
                        }
                    }else{
                        resultats.fermeture = false
                    }
                }if(listeElementsJoursO.length > 0){
                    if(listeElementsJoursO[0].horaires.ouvert === true){
                        if(listeElementsJoursO[0].horaires.matin.ouvert === true){
                            resultats.min_matin = listeElementsJoursO[0].horaires.matin.ouverture
                            resultats.max_matin = listeElementsJoursO[0].horaires.matin.fermeture
                            params.heureNumerique.forEach(heure => {
                                if(Number(listeElementsJoursO[0].horaires.matin.ouverture.slice(0, 2)) <= Number(heure) && Number(heure) <= Number(listeElementsJoursO[0].horaires.matin.fermeture.slice(0, 2))){
                                    resultats.heure.push(heure)
                                    let listeHeure = {
                                        id: heure,
                                        minutes: []
                                    }

                                }
                            })
                        }
    
                        if(listeElementsJoursO[0].horaires.apres_midi.ouvert === true){
                            resultats.min_apres_midi = listeElementsJoursO[0].horaires.apres_midi.ouverture
                            resultats.max_apres_midi = listeElementsJoursO[0].horaires.apres_midi.fermeture
                            params.heureNumerique.forEach(heure => {
                                if(Number(listeElementsJoursO[0].horaires.apres_midi.ouverture.slice(0, 2)) <= Number(heure) && Number(heure) <= Number(listeElementsJoursO[0].horaires.apres_midi.fermeture.slice(0, 2))){
                                    resultats.heure.push(heure)
                                }
                            })
    
                            params.minuteNumeriqueQH.forEach(min => {
                                if(resultats.minute.includes(min)){
    
                                }else{
                                    resultats.minute = params.minuteNumeriqueQH
                                }
                            })
                        }
                    }else{
                        resultats = {
                            fermeture: true,
                            heure: [],
                            minute: []
                        }
                    }
                }

                
                return resultats
            },

            // getAvailableSlots(date, schedules, duree) {
            //     const dayOfWeek = this.date(date).jour
            //     const slots = [];
            //     const slotDuration = duree; // durée d'un créneau en minutes
            //     const bufferBeforeClose = duree; // temps minimum avant fermeture en minutes
                
            //     // Convertit une heure au format "HH:MM" en minutes
            //     function timeToMinutes(time) {
            //         const [hours, minutes] = time.split(':').map(Number);
            //         return hours * 60 + minutes;
            //     }
                
            //     // Génère les créneaux horaires d'un intervalle d'ouverture
            //     function generateTimeSlots(start, end) {
            //         const startTime = timeToMinutes(start);
            //         const endTime = timeToMinutes(end) - bufferBeforeClose;
            //         for (let time = startTime; time <= endTime; time += slotDuration) {
            //             const hours = Math.floor(time / 60).toString().padStart(2, '0');
            //             const minutes = (time % 60).toString().padStart(2, '0');
            //             slots.push(`${hours}:${minutes}`);
            //         }
            //     }
            
            //     // Sélectionne les horaires prioritaires (extraordinaires ou ordinaires)
            //     const applicableSchedule = schedules.find(schedule => {
            //         if (schedule.horaires.jours.includes(dayOfWeek)) {
            //             if (schedule.type === "Extraordinaire") {
            //                 const startDate = new Date(schedule.horaires.debut);
            //                 const endDate = new Date(schedule.horaires.fin);
            //                 return date >= startDate && date <= endDate;
            //             }
            //             return schedule.type === "Ordinaire";
            //         }
            //         return false;
            //     });
            
            //     if (!applicableSchedule || !applicableSchedule.horaires.ouvert) {
            //         return []; // Fermé ou aucun horaire trouvé
            //     }
            
            //     // Génère les créneaux matin et après-midi
            //     const { matin, apres_midi } = applicableSchedule.horaires;
            //     if (matin.ouvert && matin.ouverture && matin.fermeture) {
            //         generateTimeSlots(matin.ouverture, matin.fermeture);
            //     }
            //     if (apres_midi.ouvert && apres_midi.ouverture && apres_midi.fermeture) {
            //         generateTimeSlots(apres_midi.ouverture, apres_midi.fermeture);
            //     }
            
            //     return slots;
            // },

            getAvailableSlots(date, schedules, duree) {
                console.log(date, schedules, duree)
                const dayOfWeek = this.date(date).jour
                const today = this.date('');
                const isToday = this.date(date).date_en === today.date_en;
                const slots = [];
                const slotDuration = duree; // durée d'un créneau en minutes
                const bufferBeforeClose = duree; // temps minimum avant fermeture en minutes
                // Convertit une heure au format "HH:MM" en minutes
                function timeToMinutes(time) {
                    const [hours, minutes] = time.split(':').map(Number);
                    return hours * 60 + minutes;
                }
                
                // Génère les créneaux horaires d'un intervalle d'ouverture
                function generateTimeSlots(start, end) {
                    const startTime = timeToMinutes(start);
                    const endTime = timeToMinutes(end) - bufferBeforeClose;
                    const currentTime = isToday ? Number(today.timenumerique.slice(0,2)) * 60 + Number(today.timenumerique.slice(3,5)) : 0; // Heure actuelle en minutes si aujourd'hui
                    for (let time = startTime; time <= endTime; time += slotDuration) {
                        // Si aujourd'hui, n'inclut que les créneaux après l'heure actuelle
                        if (!isToday || time >= currentTime) {
                            const hours = Math.floor(time / 60).toString().padStart(2, '0');
                            const minutes = (time % 60).toString().padStart(2, '0');
                            slots.push(`${hours}:${minutes}`);
                        }
                    }
                }
            
                // Sélectionne les horaires prioritaires (extraordinaires ou ordinaires)
                const applicableSchedule = schedules.find(schedule => {
                    if (schedule.horaires.jours.includes(dayOfWeek)) {
                        if (schedule.type === "Extraordinaire") {
                            const startDate = new Date(schedule.horaires.debut);
                            const endDate = new Date(schedule.horaires.fin);
                            return date >= startDate && date <= endDate;
                        }
                        return schedule.type === "Ordinaire";
                    }
                    return false;
                });
            
                if (!applicableSchedule || !applicableSchedule.horaires.ouvert) {
                    return []; // Fermé ou aucun horaire trouvé
                }
            
                // Génère les créneaux matin et après-midi
                const { matin, apres_midi } = applicableSchedule.horaires;
                if (matin.ouvert && matin.ouverture && matin.fermeture) {
                    generateTimeSlots(matin.ouverture, matin.fermeture);
                }
                if (apres_midi.ouvert && apres_midi.ouverture && apres_midi.fermeture) {
                    generateTimeSlots(apres_midi.ouverture, apres_midi.fermeture);
                }
            
                return slots;
            }
        }

    export default date


// WEBPACK FOOTER //
// ./src/functions/date.js